import React, { useEffect, useState } from 'react';
import { t } from 'ttag';

import { Button } from '@components';

export default function StoreInfo() {
  const [storeInfo, setStoreInfo] = useState(null);

  const currentDomain = window.location.hostname;

  useEffect(() => {
    const fetchStoreInfo = async () => {
      const response = await fetch(`/api/stores/?host=${currentDomain}`);
      const data = await response.json();

      if (data?.data[0]?.attributes) {
        setStoreInfo(data.data[0].attributes);
      }
    };

    fetchStoreInfo();
  }, []);

  if (!storeInfo || !storeInfo.opening_hours) return null;

  const { opening_hours: openingHours, address, image: imageSrc } = storeInfo;

  return (
    <section className="lg:border-b-1 my-4 flex flex-col-reverse border-0 md:flex-row lg:border-b lg:border-solid lg:border-whisper">
      <div className="min-h-[192px] px-3 pt-16 md:w-1/2 lg:py-20">
        <h2 className=" m-0 w-1/2 text-left text-xl font-bold  text-black before:mb-4 before:h-[1px] before:bg-gray/80 before:content-[''] sm:p-2 md:p-0">{t`The World's best football store`}</h2>
        <div className="mt-4">
          {/* {!openingHours || Object.keys(openingHours)?.length === 0 ? (
            <div>{t`Text for Norwegian site to be provided.`}</div>
          ) : ( */}
          {Object.entries(openingHours)?.map(([day, hours]) => (
            <div className="flex justify-start gap-x-16" key={day}>
              <div className="w-20 text-base font-normal text-black">
                {hours.display_name}
              </div>
              <div className="text-right text-base font-semibold text-black">
                {hours?.display}
              </div>
            </div>
          ))}
          {/* )} */}
        </div>
        <div className="mt-4 w-[130px] text-base font-normal">
          {`${address?.street}, ${address?.zip} ${address?.city}`}
        </div>

        <Button
          aria-label="Navigate"
          variant="tertiary"
          as="a"
          href={`https://www.google.com/maps/place/?q=place_id:${address?.maps_location?.place_id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="p-0 py-4"
        >
          <Button.Text className="p-0 font-bold">{t`See on the map`}</Button.Text>
          <Button.Icon className="box-border flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-green to-[#E0F65A] p-1 text-black transition-opacity">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                stroke="currentColor"
                strokeWidth="1"
                d="M16.004 9.414l-8.607 8.607-1.414-1.414L14.589 8H7.004V6h11v11h-2V9.414z"
              />
            </svg>
          </Button.Icon>
        </Button>
      </div>
      <div className="md:max-h-[384px] md:w-1/2">
        <div className="aspect-h-9 aspect-w-16 h-full overflow-hidden rounded-lg shadow-lg lg:aspect-none">
          <img
            src={imageSrc}
            alt="Flagship Store"
            className="h-full w-full object-cover object-center lg:h-full lg:w-full"
          />
        </div>
      </div>
    </section>
  );
}
